export enum PageViewMode {
    Single = 'single',
    Multiple = 'multiple',
    InfiniteScroll = 'infinite-scroll',
    Book = 'book'
};
